import { useQuery } from "@tanstack/react-query";
import { CpuIcon, GlobeIcon, CheckCircleIcon, CircleIcon } from "@phosphor-icons/react";
import { fetchCoinTech } from "../lib/api";

const CYAN = "#22D3EE";
const scoreColor = (s) => (s >= 80 ? CYAN : s >= 60 ? "#4ADE80" : s >= 45 ? "#F0C000" : "#888");

export const TechScorePanel = ({ address }) => {
  const { data } = useQuery({ queryKey: ["coinTech", address], queryFn: () => fetchCoinTech(address), enabled: !!address });
  if (!data || !data.hasWebsite) return null; // only show for real-product tokens

  return (
    <div className="border border-white/10 bg-card p-4 space-y-3" data-testid="tech-score-panel">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <CpuIcon size={18} weight="fill" style={{ color: CYAN }} />
          <span className="font-heading font-bold text-sm">Tech Score</span>
          {data.isTech && <span className="text-[9px] font-mono px-1.5 py-0.5" style={{ background: `${CYAN}18`, border: `1px solid ${CYAN}66`, color: CYAN }}>REAL PRODUCT</span>}
        </div>
        <div className="font-heading font-black text-3xl leading-none" style={{ color: scoreColor(data.techScore) }} data-testid="tech-score-value">{data.techScore}</div>
      </div>

      <p className="text-[11px] text-muted-foreground leading-relaxed">
        How "tech / real product" this looks vs a pure meme — a website, real socials and utility signals score higher. Not a guarantee, always DYOR.
      </p>

      <div className="space-y-1.5">
        {(data.breakdown || []).map((b, i) => (
          <div key={i} className="flex items-center gap-2 text-xs" data-testid={`tech-bd-${i}`}>
            {b.hit ? <CheckCircleIcon size={15} weight="fill" style={{ color: b.points > 0 ? "#4ADE80" : "#666" }} /> : <CircleIcon size={15} style={{ color: "#444" }} />}
            <span className={b.hit ? "text-white" : "text-muted-foreground line-through decoration-white/20"}>{b.label}</span>
            <span className="ml-auto font-mono" style={{ color: b.hit && b.points > 0 ? "#4ADE80" : "#555" }}>{b.points > 0 ? `+${b.points}` : "0"}</span>
          </div>
        ))}
      </div>

      {data.website && (
        <a href={data.website} target="_blank" rel="noreferrer" data-testid="tech-panel-website" className="flex items-center justify-center gap-1.5 text-xs font-semibold px-3 py-2 border border-white/15 hover:border-[#22D3EE]/50 hover:text-[#22D3EE] transition-colors">
          <GlobeIcon size={14} weight="bold" /> Visit website
        </a>
      )}
    </div>
  );
};
